// Importa Firebase
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

// Configura con i dati del tuo progetto Firebase
const firebaseConfig = {

  apiKey: "AIzaSyAymXAjA0_xtdlPe3u2KZc53PtDT7LpXg0",

  authDomain: "d1-roller.firebaseapp.com",

  projectId: "d1-roller",

  storageBucket: "d1-roller.firebasestorage.app",

  messagingSenderId: "962884849605",

  appId: "1:962884849605:web:679fd3b4ebf0bb5506c5ac"

};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

